import Vue from 'vue';
import { Module } from 'vuex';
import { RootState } from '@/types/store';
import { ParticipationModel } from './model/participation';
import { getMapKey, isUndef } from '@/lib/utils';

export interface ParticipationState {
    /** 报名列表 */
    list: {
        [mapkey_activityId_active_finish: string]: ParticipationModel[];
    };
    signInStat: Participation.SignInStat[] | null;
    stat: Participation.Stat | null;
}

const m: Module<ParticipationState, RootState> = {
    namespaced: true,
    state: {
        list: {},
        signInStat: null,
        stat: null,
    },
    mutations: {
        /**
         * 设置活动报名列表
         */
        setList(state, { key, list }: { key: string; list: Participation.ListItem[] }) {
            Vue.set(state.list, key, list.map((item) => new ParticipationModel(item)));
        },
        /**
         * 记录统计数据
         */
        setSignInStat(state, stat) {
            state.signInStat = stat;
        },
        /**
         * 记录统计数据
         */
        setStat(state, stat) {
            state.stat = stat;
        },
    },
    actions: {
        /**
         * 获取活动报名列表
         * activityId: 可不传
         * active: 默认 是，是否仅仅限于进行中
         * finish: 是否已完赛
         */
        async getList({ state, commit }, { activityId, active, finish } = {}) {
            const params: any = {};
            console.log('target123123132123', activityId, active, finish);
            const key = getMapKey({
                activityId,
                active,
                finish,
            });
            if (activityId) {
                params.activity_id = activityId;
            }
            if (!isUndef(active)) {
                params.active = active ? 1 : 0;
            }
            if (!isUndef(finish)) {
                params.finish = finish ? 1 : 0;
            }
            const response = await Vue.axios.get('/api/v1/participation/list', {
                params,
            });
            const rdata = response.data;
            console.log('target 报名数据1-1', rdata, key);
            if (rdata.status === 0) {
                commit('setList', {
                    key,
                    list: rdata.data,
                });
            }
            return rdata;
        },
        /**
         * 获取活动报名列表
         */
        async getSignInStat({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/participation/sign_in_stat');
            const rdata = response.data;
            console.log('target 111111', rdata.data);
            if (rdata.status === 0) {
                commit('setSignInStat', rdata.data);
            }
            return rdata;
        },
        /**
         * 获取数据统计
         */
        async getStat({ state, commit }) {
            const response = await Vue.axios.get('/api/v1/participation/stat');
            const rdata = response.data;
            if (rdata.status === 0) {
                commit('setStat', rdata.data);
            }
            return rdata;
        },
        /**
         * 获取套餐数据
         */
        async getShowAlert() {
            const res = await Vue.axios.get('/api/v1/participation/current');
            const rdata = res.data;
            return rdata;
        },
        /**
         * 弹窗
         */
        async alert(context, id) {
            const res = await Vue.axios.post('/api/v1/participation/alert', {
                participation_sign_in_id: id
            });
            const rdata = res.data;
            return rdata;
        },
    },
};

export default m;
